<template>
  <VaLayout class="w-full overflow-y-scroll">
    <template #content>
      <main class="w-full">
        <div class="flex flex-col items-center">
          <RouterView />
        </div>
      </main>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup></script>
